(function () {
  const colors = ['#84E6B9', '#EA5463', '#78B1FF', '#B46DE4'];
  [].forEach.call(document.querySelectorAll('#books .book'), (el) => {
    el.style['border-color'] =
      colors[Math.floor(Math.random() * colors.length)];
  });
})();
